export default __webpack_public_path__ + "static/media/patent1image.9b98fef3.png";